interface AgentChatState {
  unreadCount: number;
  latestAgentId: string | null;
  latestAgentName: string | null;
}

let state: AgentChatState = {
  unreadCount: 0,
  latestAgentId: null,
  latestAgentName: null,
};

const listeners = new Set<() => void>();

export function getState(): AgentChatState {
  return state;
}

export function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}

export function incrementUnread(agentId: string, agentName: string): void {
  state = {
    unreadCount: state.unreadCount + 1,
    latestAgentId: agentId,
    latestAgentName: agentName,
  };
  listeners.forEach((cb) => cb());
}

export function markRead(): void {
  state = { unreadCount: 0, latestAgentId: null, latestAgentName: null };
  listeners.forEach((cb) => cb());
}
